export const NO_CREDENTIALS_ID = -1;
